import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import retirementReasonOptions from '@/utils/format-edit/retirementReasonOptions.json'
import {
  buildJobHistories,
  createEmptyCompany,
  isCompanyEmpty,
  type JobHistoryListItem
} from '@/utils/format-edit/jobHistoryAuto'


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoJobHistories',
  props: {
    birthYear: null,
    birthMonth: null,
    birthDay: null
  },
  emits: ["job-histories-created"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'job-histories-created', list: JobHistoryListItem[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  birthYear?: number | string
  birthMonth?: number | string
  birthDay?: number | string
};





const { formLib } = useHostServices()

const showJobDialog = ref(false)
const isContinuing = ref(false)
const retirementReason = ref('')
const errorMessage = ref('')
const company = reactive(createEmptyCompany())

const calcMinYear = computed(() =>
  props.birthYear ? Number(props.birthYear) + 15 : 1900
)
const calcMaxYear = computed(() => new Date().getFullYear() + 3)

function resetCompany() {
  Object.assign(company, createEmptyCompany())
  isContinuing.value = false
}

function openJobDialog() {
  resetCompany()
  showJobDialog.value = true
}

function closeDialog() {
  showJobDialog.value = false
}

function setJobHistories() {
  errorMessage.value = ''
  if (isCompanyEmpty(company)) {
    return
  }
  const jobHistories = buildJobHistories({
    company,
    isContinuing: isContinuing.value,
    retirementReason: retirementReason.value
  })
  emit('job-histories-created', jobHistories)
  closeDialog()
}

return { __sfc: true,props, emit, formLib, showJobDialog, isContinuing, retirementReason, errorMessage, company, calcMinYear, calcMaxYear, resetCompany, openJobDialog, closeDialog, setJobHistories, retirementReasonOptions }
}

})